import { cloneQuery } from '@esentai/core/queries';

export default () => (state, { payload: sort }) => {
  const queryClone = cloneQuery(state);

  queryClone.set('sort', sort);

  return queryClone;
};
